import React, { useEffect } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { parsePath } from './siteRoutes.js';
import { readLang } from './siteLang';
import siteTheme from '../theme/site';
import './site.css';

// Website Chatbox: the widget of Aiker's e-commerce account (07sml.onesuite.com).
// The key is public by design; it only opens that widget's chat page.
export const SITE_CHAT_KEY = 'cw_IKjSrZVkwKnONxNXHOagPDCh';

// The public website ships its own Chakra theme (delivered by the business team).
// Scope it to the site pages so the console keeps the app theme.
// The loader adds the chat button once per page load; site.css hides it whenever
// the html element loses the site-page class (client-side navigation into the console).
export default function SiteShell({ children, chat = true }) {
  // Site language: the /zh prefix on site pages; the saved choice on the legal pages.
  const { pathname } = useLocation();
  const lang = parsePath(pathname)?.lang || readLang();

  useEffect(() => {
    const targets = [document.documentElement, document.body];
    targets.forEach((el) => el.classList.add('site-page'));
    return () => targets.forEach((el) => el.classList.remove('site-page'));
  }, []);

  useEffect(() => {
    if (!chat || document.querySelector('script[data-site-chat]')) return;
    const script = document.createElement('script');
    script.src = '/chat-widget.js';
    script.async = true;
    script.setAttribute('data-key', SITE_CHAT_KEY);
    script.setAttribute('data-lang', lang);
    script.setAttribute('data-site-chat', '');
    document.body.appendChild(script);
  }, [chat]); // eslint-disable-line react-hooks/exhaustive-deps

  // The button and chat follow the site's EN/中文 switch, not the browser language.
  useEffect(() => {
    if (chat && window.AikerChat) window.AikerChat.setLang(lang);
  }, [chat, lang]);

  return <ChakraProvider theme={siteTheme}>{children}</ChakraProvider>;
}
